// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Calendly = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Calendly = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Calendly = _exports.Calendly = function Calendly(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14247)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.3401 17.7113V17.7114C19.3455 18.8435 18.428 19.7611 17.2958 19.7611H2.70823C1.58146 19.7611 0.663904 18.8435 0.663904 17.7167V3.12375C0.663904 1.99699 1.58146 1.07943 2.70823 1.07943H17.2958C18.4225 1.07943 19.3401 1.99699 19.3401 3.12375V17.7113ZM2.70823 2.17227C2.18213 2.17227 1.75675 2.59766 1.75675 3.12375V17.7113C1.75675 18.2374 2.18213 18.6628 2.70823 18.6628H17.2958C17.8219 18.6628 18.2472 18.2374 18.2472 17.7113V3.12375C18.2472 2.59766 17.8219 2.17227 17.2958 2.17227H2.70823Z",
      fill: "#676B74",
      stroke: "#212B36",
      "stroke-width": "0.0543703"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.1874 4.15076C13.9428 4.15076 13.747 3.95503 13.747 3.71036V0.654755C13.747 0.410088 13.9428 0.214355 14.1874 0.214355C14.4321 0.214355 14.6278 0.410088 14.6278 0.654755V3.70493C14.6278 3.94959 14.4321 4.15076 14.1874 4.15076ZM5.77634 4.15076C5.53167 4.15076 5.33594 3.95503 5.33594 3.71036V0.654755C5.33594 0.410088 5.53167 0.214355 5.77634 0.214355C6.021 0.214355 6.21674 0.410088 6.21674 0.654755V3.70493C6.22217 3.94959 6.021 4.15076 5.77634 4.15076ZM10.5337 14.0135C8.70689 14.0135 7.22259 12.5292 7.22259 10.7024C7.22259 8.87554 8.70689 7.39123 10.5337 7.39123C11.3602 7.39123 12.1485 7.69571 12.7575 8.25028C12.8336 8.31553 12.839 8.43514 12.7684 8.50582C12.7031 8.58194 12.5835 8.58738 12.5128 8.5167C11.9691 8.02193 11.2677 7.75008 10.5337 7.75008C8.90806 7.75008 7.58687 9.07127 7.58687 10.6969C7.58687 12.3226 8.90806 13.6438 10.5337 13.6438C11.2677 13.6438 11.9691 13.372 12.5128 12.8772C12.5889 12.8119 12.7031 12.8174 12.7684 12.8881C12.8336 12.9642 12.8282 13.0784 12.7575 13.1436C12.1485 13.7091 11.3602 14.0135 10.5337 14.0135Z",
      fill: "#676B74"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14247"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "white"
    }))));
  };
});
